import { createConditionalValidator } from 'utils/yup';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  other_investments_amount: createConditionalValidator(
    'renovation_house_other_investments',
    'number',
  ),
  other_investments_comment: createConditionalValidator(
    'renovation_house_other_investments',
    'string',
  ),
});

export default validationSchema;
